function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import cn from 'classnames';
import { Typography, Badge, Tooltip } from 'seagull';
import BadgesList from "./BadgesList/BadgesList";
import PriceDisplay from "./PriceDisplay/PriceDisplay";
import EditablePrice from "./EditablePrice/EditablePrice";
import IncludedServices from "../IncludedServices/IncludedServices";
import { discountBadge } from "../../utils/service-description/getServiceDescriptionBadges";
import ServiceDescription from "./ServiceDescription/ServiceDescription";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import BulletPointsSection from "./BulletPointsSection/BulletPointsSection";
import { renderBillingSettingsSection } from "./BillingSettingsSection/BillingSettingsSection";
import { getPriceDisplayProps, getStatusBadgeText, getPausedBadge } from "./ServiceDetails.utils";
import { serviceModel } from "../../models";
import BillingInitiationControl from "./BillingInitiationControl/BillingInitiationControl";
import styles from "./ServiceDetails.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ServiceDetails(props) {
  var _service$bundle;
  const {
    testid,
    menu,
    agreementData,
    showBadges,
    showBulletPoints,
    billingInitiationProps,
    isFreshlyAdded = false,
    additionalSections,
    isVendor,
    disableEditBillUpfront,
    disableEditBillingDay,
    disableStatusBadge = false,
    disableEditCost,
    disableEditBillingInitiation,
    isReadOnly,
    ignoreAmendments,
    error,
    onCostChange,
    onHasError,
    onDayOfMonthChange,
    onDayOfWeekChange,
    onBillUpfrontModeChange,
    onChangeService,
    onDayOfYearChange,
    onIncludedServicesChange,
    context
  } = props;
  const {
    SERVICE_TEMPLATE_BUNDLE
  } = useFeatureFlags();
  const service = ignoreAmendments ? props.service : serviceModel.applyChanges(props.service);
  const isActiveAgreement = agreementData.isActiveAgreement();
  const statusBadgeText = getStatusBadgeText(service, isActiveAgreement, disableStatusBadge);
  const pausedBadge = getPausedBadge(service, isVendor, isActiveAgreement);
  const discountBadgeData = discountBadge(service);
  const priceDisplayProps = getPriceDisplayProps(service);
  const isBundle = Boolean(SERVICE_TEMPLATE_BUNDLE && serviceModel.isBundle(service));
  return /*#__PURE__*/_jsxs("div", {
    className: styles.serviceDetails,
    "data-testid": "".concat(testid, "service-details"),
    "data-serviceid": service.id,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.descriptionAndMenuButtonContainer,
      children: [/*#__PURE__*/_jsxs("div", {
        className: cn(styles.detailedDescription, {
          [styles.withBadge]: !!statusBadgeText
        }),
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h6",
          ellipsis: true,
          "data-testid": testid + 'name',
          children: service.name
        }), /*#__PURE__*/_jsx(ServiceDescription, {
          service: service,
          testid: testid
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.badgeAndDotMenuContainer,
        children: [pausedBadge && /*#__PURE__*/_jsx(Tooltip, {
          title: pausedBadge.tooltip,
          placement: "top",
          children: /*#__PURE__*/_jsx(Badge, {
            outlined: true,
            "data-testid": "service-details-paused-badge",
            children: "Paused"
          })
        }), statusBadgeText && /*#__PURE__*/_jsx(Badge, {
          outlined: true,
          "data-testid": "".concat(testid, "status-badge"),
          children: statusBadgeText
        }), menu]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.finalPriceContainer,
      children: [onCostChange && onChangeService ? /*#__PURE__*/_jsx(EditablePrice, {
        serviceWithChanges: service,
        service: props.service,
        testid: testid,
        disableEditCost: disableEditCost,
        isReadOnly: isReadOnly,
        showDiscountError: !!priceDisplayProps.error,
        onCostChange: onCostChange,
        onChangeService: onChangeService
      }) : /*#__PURE__*/_jsx(PriceDisplay, _objectSpread(_objectSpread({}, priceDisplayProps), {}, {
        "data-testid": testid
      })), showBadges ? /*#__PURE__*/_jsx(BadgesList, {
        service: service,
        agreementData: agreementData,
        testid: testid,
        isFreshlyAdded: isFreshlyAdded,
        context: context
      }) : discountBadgeData && /*#__PURE__*/_jsx("div", {
        "data-testid": testid + 'discount',
        children: /*#__PURE__*/_jsx(Badge, {
          skin: discountBadgeData.skin,
          children: discountBadgeData.text
        })
      })]
    }), isBundle && /*#__PURE__*/_jsx("div", {
      className: styles.includedServicesContainer,
      children: /*#__PURE__*/_jsx(IncludedServices, {
        showErrors: error,
        mode: isReadOnly ? 'readonly' : 'editAndDelete',
        value: ((_service$bundle = service.bundle) === null || _service$bundle === void 0 ? void 0 : _service$bundle.services) || [],
        onChange: value => onIncludedServicesChange && onIncludedServicesChange(value),
        tooltip: "Included service rates are hidden from the client"
      })
    }), billingInitiationProps && /*#__PURE__*/_jsx(BillingInitiationControl, _objectSpread(_objectSpread({
      service: service,
      disabled: isReadOnly || disableEditBillingInitiation,
      agreementData: agreementData,
      showError: error,
      isFreshlyAdded: isFreshlyAdded
    }, billingInitiationProps), {}, {
      testid: testid + 'billing-initiation',
      onChange: onChangeService
    })), showBulletPoints ? /*#__PURE__*/_jsx(BulletPointsSection, _objectSpread({}, props)) : onDayOfWeekChange && onDayOfMonthChange && onDayOfYearChange && onBillUpfrontModeChange && renderBillingSettingsSection({
      testid,
      service,
      className: styles.section,
      isReadOnly,
      isActiveAgreement,
      disableBillUpfront: disableEditBillUpfront,
      disableBillingDay: disableEditBillingDay,
      onHasError,
      onDayOfWeekChange,
      onDayOfMonthChange,
      onBillUpfrontModeChange,
      onDayOfYearChange
    }), additionalSections === null || additionalSections === void 0 ? void 0 : additionalSections.map((_ref, idx) => {
      let {
        value,
        disableBorder
      } = _ref;
      return value && /*#__PURE__*/_jsx("div", {
        className: cn(styles.additionalSection, disableBorder && styles.disableBorder),
        children: value
      }, idx);
    })]
  });
}